<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="600"
  >
    <div class="telefone-whatsapp-modal">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-left">
            <div class="header-icon">
              <v-icon>mdi-whatsapp</v-icon>
            </div>
            <div class="header-text">
              <h2 class="header-title">Selecione o telefone do paciente</h2>
            </div>
          </div>
          <v-btn icon class="close-btn" @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="unified-content">
        <v-card class="unified-card">
          <div class="form-content">
            <v-radio-group v-model="telefoneSelecionado" class="modern-radio-group">
              <v-radio
                v-if="paciente.contato?.telefonePrincipal"
                :label="paciente.contato.telefonePrincipal"
                value="1"
                color="success"
              >
              </v-radio>
              <v-radio
                class="mt-2"
                v-if="paciente.contato?.telefoneSecundario"
                :label="paciente.contato.telefoneSecundario"
                value="2"
                color="success"
              >
              </v-radio>
              <v-radio color="primary" value="3">
                <template v-slot:label>
                  <soi-input
                    class="mt-3"
                    :disabled="telefoneSelecionado !== '3'"
                    :name="'Outro'"
                    :label="'Outro:'"
                    v-model="outroTelefone"
                    :mask="masks.telefone"
                    :placeholder="'(00) 00000-0000'"
                  ></soi-input>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
          <div class="form-actions">
            <div class="actions-container">
              <v-btn
                class="action-btn whatsapp-btn"
                :disabled="botaoDesabilitado"
                @click="abrirWhatsApp"
              >
                <v-icon left>mdi-whatsapp</v-icon>
                Abrir WhatsApp
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import MaskHelper from '../../helpers/MaskHelper';
import { AlertaSimplesErro } from '@/helpers/MensagemHelper';

export default Vue.extend({
  name: 'ModalSelecionarTelefoneWhatsApp',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    paciente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      telefoneSelecionado: '',
      outroTelefone: '',
      masks: MaskHelper,
    };
  },
  computed: {
    botaoDesabilitado(): boolean {
      return this.telefoneSelecionado === '' || (this.telefoneSelecionado === '3' && this.outroTelefone === '');
    },
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        // Resetar valores quando modal fechar
        this.telefoneSelecionado = '';
        this.outroTelefone = '';
      }
    },
  },
  methods: {
    abrirWhatsApp() {
      let telefone: string;

      switch (this.telefoneSelecionado) {
        case '1':
          telefone = this.paciente.contato.telefonePrincipal;
          break;
        case '2':
          telefone = this.paciente.contato.telefoneSecundario;
          break;
        case '3':
          telefone = this.outroTelefone;
          break;
        default:
          AlertaSimplesErro('Escolha um telefone válido', 'Escolha um telefone válido');
          return;
      }

      telefone = telefone.replace(/[^0-9]+/g, '');

      this.$emit('abrirWhatsApp', {
        telefone: `55${telefone}`,
      });
    },
  },
});
</script>

<style scoped>
/* === MODAL TELEFONE WHATSAPP === */
.telefone-whatsapp-modal {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* === HEADER COMUM === */
.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  color: white;
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: white;
}

.close-btn {
  color: white !important;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.close-btn:hover {
  opacity: 1;
}

/* === CONTEÚDO UNIFICADO === */
.unified-content {
  padding: 32px;
}

.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.form-content {
  padding: 24px;
}

/* === RADIO GROUP MODERNO === */
.modern-radio-group .v-radio {
  margin-bottom: 16px;
}

.modern-radio-group .v-input--selection-controls__input {
  margin-right: 12px;
}

/* === AÇÕES === */
.form-actions {
  padding: 24px 32px;
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.actions-container {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.action-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 24px !important;
  height: 48px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
}

.whatsapp-btn {
  background: #25d366 !important;
  color: white !important;
}

.whatsapp-btn:hover {
  background: #1ea952 !important;
}

.whatsapp-btn:disabled {
  background: #e9ecef !important;
  color: #6c757d !important;
  box-shadow: none !important;
  transform: none !important;
}

/* === RESPONSIVIDADE === */
@media (max-width: 768px) {
  .telefone-whatsapp-modal {
    margin: 16px;
    border-radius: 16px;
  }

  .modal-header {
    padding: 20px 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .unified-content {
    padding: 24px;
  }

  .form-content {
    padding: 16px;
  }

  .form-actions {
    padding: 20px 24px;
  }

  .actions-container {
    flex-direction: column;
    gap: 8px;
  }

  .action-btn {
    width: 100%;
  }
}
</style>
